import { Button, Overlay, Icon, Tab, Tabs } from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import WebFont from "webfontloader";
import { BackgroundComponet } from "../../components/Background";
import { CanvasArea } from "../../components/CanvasArea";
import { ElementsComponet } from "../../components/Elements";
import { fontFamilyPicker } from "../../components/FontFamily";
// HIDE:- import { LayerManagementComponent } from "../../components/LayerManagement";
// import { IdContext } from "../../components/Contexts/IdContext";
import { Logo } from "../../components/Logo";
import { Pagination } from "../../components/Pagination";
import { Templates } from "../../components/Templates";
import { TextComponet } from "../../components/Text";
import { EditTextComponent } from "../../components/EditText";
import { ToolBar } from "../../components/Toolbar";
import { AddToCart } from "../../components/Toolbar/AddToCart";
import { PreviewGenerate } from "../../components/Toolbar/PreviewGenerate";
import { BackButton } from "../../components/Toolbar/BackButton";
import { UndoRedoComponent } from "../../components/Toolbar/UndoRedo";
import { UploadComponet } from "../../components/Upload";
import { ZoomCanvas } from "../../components/Zoom";
import { PhotoFrame } from "../../components/PhotoFrame";
import { closeTab } from "../../utils/helper";
import { PreviewScreen } from "../../components/Preview/PreviewScreen";
import "./home.css";

export function Home() {
  const { sessionId, apiUrl, cartKey, loadCategories, createID, updateID } = useParams();
  const [elementStrokColor, setelementStrokColor] = useState(false);
  const [showUploadToolbar, setshowUploadToolbar] = useState(false);
  const [showTextToolbar, setTextToolbar] = useState(false);
  const [activeTab, setActiveTab] = useState("Templates");
  const [canvasObjects, setCanvasObjects] = useState([]);
  const [showToolbar, setShowToolbar] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0); // Initial selected index
  const [lable, setLable] = useState(1); // Initial selected index
  const [disabledObj, setdisabledObj] = useState(false);
  const [templateID, settemplateID] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [canvasObj, setcanvasObj] = useState(false);
  const [LockObj, setLockObj] = useState("unlock");
  const [canvases, setcanvases] = useState([]);
  const [canvasesOriganl, setcanvasesOriganl] = useState([]);
  const [loader, setLoader] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [TemplateData, setTemplateData] = useState('');
  const [CategoriesData, setCategoriesData] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const captureInitialStateRef = useRef(null);
  // const { setId } = useContext(IdContext);

  useEffect(() => {
    /* if (createID) {
      setId(createID);
    }
    if (updateID) {
      setId(updateID);
    } */

    // Set current tab for edit & create.
    if (createID || updateID) {
      setActiveTab("EditText");
    }
  }, [updateID, createID]);

  useEffect(() => {
    // Load webfont.
    WebFont.load({
      google: {
        families: fontFamilyPicker,
      },
    });
  }, []);

  // Set canvas object and toolbar state for active page. Re-run when canvases or page changes (e.g. template load).
  useEffect(() => {
    if (!canvases || canvases.length === 0) return;

    const activeCanvas = canvases[currentPage - 1];
    if (!activeCanvas) return;

    setcanvasObj(activeCanvas);

    const handleMouseDown = function () {
      const activeOBJ = activeCanvas.getActiveObject();
      if (activeOBJ) {
        const type = activeOBJ.get("type");
        setdisabledObj(false);
        setShowToolbar(true);
        if (type === "textbox") {
          setTextToolbar(true);
          setelementStrokColor(false);
          setshowUploadToolbar(false);
        } else if (type === "image") {
          setTextToolbar(false);
          setelementStrokColor(false);
          setshowUploadToolbar(true);
        } else {
          setTextToolbar(false);
          setelementStrokColor(true);
          setshowUploadToolbar(false);
        }
      }
    };

    activeCanvas.on("mouse:down", handleMouseDown);

    return function cleanup() {
      if (activeCanvas && typeof activeCanvas.off === "function") {
        activeCanvas.off("mouse:down", handleMouseDown);
      }
    };
  }, [currentPage, canvases]);

  // CLEAR: Tab change event.
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    // Additional logic for tab click event
    var tabIDValue = document.getElementById(
      `bp4-tab-panel_sidepanel_${tabId}`
    );
    if (tabIDValue) {
      tabIDValue.setAttribute("aria-hidden", "false");
    }
  };

  const toggleOverlay = () => {
    setIsOpen(false)
  }

  return (
    <div className="main-container">
      <div className="top-header">
        <div className="site-logo">
          <Logo />
        </div>
        <div className="addto-cart">
          {!previewOpen && (
            <>
              <ZoomCanvas Canvaseditor={canvasObj} />
              <UndoRedoComponent
                Canvaseditor={canvasObj}
                activePage={currentPage}
                templateID={templateID}
                captureInitialStateRef={captureInitialStateRef}
              />
            </>
          )}
          {(sessionId && apiUrl && cartKey && loadCategories) ? (
            ''
          ) : (<PreviewGenerate Canvaseditor={canvasObj} />)}

          {/* {sessionId && apiUrl && cartKey && loadCategories && !previewOpen && ( */}
          {true && (
            <>
              {lable == 1 ? (
                (sessionId && apiUrl && cartKey && loadCategories && !previewOpen) ? (
                  <div className="bp4-navbar-group bp4-align-left">
                    <Button
                      onClick={() => {
                        setPreviewOpen(true)
                        setImages([])
                      }}
                      icon={<Icon icon="shopping-cart" />}
                      text="Preview and add to cart"
                    />
                  </div>
                ) : ('')
              ) : (
                <AddToCart
                  sessionId={sessionId}
                  apiUrl={apiUrl}
                  cartKey={cartKey}
                  loadCategories={loadCategories}
                  canvases={canvases}
                  canvasObjects={canvasObjects}
                  images={images}
                  TemplateData={TemplateData}
                  CategoriesData={CategoriesData}
                  setLoader={setLoader}
                />
              )}
            </>
          )}
          {/* {sessionId && apiUrl && cartKey && loadCategories && ( */}
          {previewOpen && (
            <>
              <div className="bp4-navbar-group bp4-align-left margin-left-10">
                <Button
                  onClick={() => {
                    // window.location.reload()
                    setPreviewOpen(false)
                  }}
                  icon={<Icon icon="circle-arrow-left" />}
                  text="Edit Design"
                />
              </div>
              <AddToCart
                sessionId={sessionId}
                apiUrl={apiUrl}
                cartKey={cartKey}
                loadCategories={loadCategories}
                canvases={canvases}
                canvasObjects={canvasObjects}
                images={images}
                TemplateData={TemplateData}
                CategoriesData={CategoriesData}
                setLoader={setLoader}
              />
            </>
          )}
          {(createID || updateID) && <BackButton />}
          {/* NotCleared:- Left Side Panel & Tabs */}
        </div>
      </div>
      <div className="main-section">
        {previewOpen &&
          <>
            <Overlay
              autoFocus={false}
              enforceFocus={true}
              usePortal={true}
              canOutsideClickClose={false}
              canEscapeKeyClose={false}
              hasBackdrop={false}
              isOpen={previewOpen}
              className={"Overlay-modal"}
              onClose={() => toggleOverlay}>
              <PreviewScreen
                canvases={canvases}
                templateID={templateID}
                previewOpen={previewOpen}
                images={images}
                setImages={setImages}
                TemplateData={TemplateData}
                setTemplateData={setTemplateData}
                CategoriesData={CategoriesData}
                setCategoriesData={setCategoriesData}
                canvasesOriganl={canvasesOriganl}
              />
            </Overlay>
          </>
        }
        {!previewOpen && (
          <div className="tabpanel">
            {/* Left Side Panel & Tabs */}
            <div className="side-panel">
              <Tabs
                id="sidepanel"
                animate={false}
                vertical={true}
                large={false}
                selectedTabId={activeTab}
                onChange={handleTabChange}
                renderActiveTabPanelOnly={true}
              >
                {!createID && !updateID && (
                  <Tab
                    id="Templates"
                    title={
                      <>
                        <div className="left-tab">
                          <Icon size="18" icon="control" />
                        </div>
                        <div className="left-tab-text">Templates</div>
                      </>
                    }
                    panel={
                      <div className="tab-content">
                        <Templates
                          setLoader={setLoader}
                          settemplateID={settemplateID}
                          templateID={templateID}
                        />
                        <Button
                          onClick={closeTab}
                          className="close-tab"
                          icon={<Icon icon="caret-left" />}
                        />
                      </div>
                    }
                  />
                )}
                <Tab
                  id="EditText"
                  title={
                    <>
                      <div className="left-tab">
                        <Icon size="18" icon="manually-entered-data" />
                      </div>
                      <div className="left-tab-element">Quick Edit</div>
                    </>
                  }
                  panel={
                    <div className="tab-content">
                      <EditTextComponent Canvaseditor={canvasObj} />
                      <Button
                        onClick={closeTab}
                        className="close-tab"
                        icon={<Icon icon="caret-left" />}
                      />
                    </div>
                  }
                />
                <Tab
                  id="Text"
                  title={
                    <>
                      <div className="left-tab">
                        <Icon size="18" icon="new-text-box" />
                      </div>
                      <div className="left-tab-text">Text</div>
                    </>
                  }
                  panel={
                    <div className="tab-content">
                      <TextComponet
                        setshowUploadToolbar={setshowUploadToolbar}
                        setelementStrokColor={setelementStrokColor}
                        setTextToolbar={setTextToolbar}
                        Canvaseditor={canvasObj}
                        setShowToolbar={setShowToolbar}
                        closeTab={closeTab}
                      />
                      <Button
                        onClick={closeTab}
                        className="close-tab"
                        icon={<Icon icon="caret-left" />}
                      />
                    </div>
                  }
                />
                <Tab
                  id="Elements"
                  title={
                    <>
                      <div className="left-tab">
                        <Icon size="18" icon="comparison" />
                      </div>
                      <div className="left-tab-element">Elements</div>
                    </>
                  }
                  panel={
                    <div className="tab-content">
                      <ElementsComponet
                        setshowUploadToolbar={setshowUploadToolbar}
                        setelementStrokColor={setelementStrokColor}
                        setTextToolbar={setTextToolbar}
                        Canvaseditor={canvasObj}
                        setShowToolbar={setShowToolbar}
                        closeTab={closeTab}
                      />
                      <Button
                        onClick={closeTab}
                        className="close-tab"
                        icon={<Icon icon="caret-left" />}
                      />
                    </div>
                  }
                />
                <Tab
                  id="Uploads"
                  title={
                    <>
                      <div className="left-tab">
                        <Icon size="18" icon="cloud-upload" />
                      </div>
                      <div className="left-tab-element">Uploads</div>
                    </>
                  }
                  panel={
                    <div className="tab-content">
                      <UploadComponet
                        setshowUploadToolbar={setshowUploadToolbar}
                        setelementStrokColor={setelementStrokColor}
                        setTextToolbar={setTextToolbar}
                        Canvaseditor={canvasObj}
                        setShowToolbar={setShowToolbar}
                        closeTab={closeTab}
                      />
                      <Button
                        onClick={closeTab}
                        className="close-tab"
                        icon={<Icon icon="caret-left" />}
                      />
                    </div>
                  }
                />
                { /* <Tab
                id="Frame"
                title={
                  <>
                    <div className="left-tab">
                      <Icon size="18" icon="mugshot" />
                    </div>
                    <div className="left-tab-element">Photo Frame</div>
                  </>
                }
                panel={
                  <div className="tab-content">
                    <PhotoFrame
                      setshowUploadToolbar={setshowUploadToolbar}
                      setelementStrokColor={setelementStrokColor}
                      setTextToolbar={setTextToolbar}
                      Canvaseditor={canvasObj}
                      setShowToolbar={setShowToolbar}
                      closeTab={closeTab}
                    />
                    <Button
                      onClick={closeTab}
                      className="close-tab"
                      icon={<Icon icon="caret-left" />}
                    />
                  </div>
                }
              /> */ }
                <Tab
                  id="Background"
                  title={
                    <>
                      <div className="left-tab">
                        <Icon size="18" icon="layout-grid" />
                      </div>
                      <div className="left-tab-element">Background</div>
                    </>
                  }
                  panel={
                    <div className="tab-content">
                      <BackgroundComponet
                        Canvaseditor={canvasObj}
                        setShowToolbar={setShowToolbar}
                        closeTab={closeTab}
                      />
                      <Button
                        onClick={closeTab}
                        className="close-tab"
                        icon={<Icon icon="caret-left" />}
                      />
                    </div>
                  }
                />
                {/* HIDE:- Hide the Layer Management */}
                {/* <Tab
							id='Layer Management'
							title={
								<>
									<div className='left-tab'>
										<Icon size='18' icon='layers' />
									</div>
									<div className='left-tab-element'>Layer Management</div>
								</>
							}
							panel={
								<div className='tab-content'>
									<LayerManagementComponent
										Canvaseditor={canvasObj}
										setShowToolbar={setShowToolbar}
										closeTab={closeTab}
									/>
									<Button
										onClick={closeTab}
										className='close-tab'
										icon={<Icon icon='caret-left' />}
									/>
								</div>
							}
						/> */}
              </Tabs>
            </div>
          </div>
        )}

        {/* Right Side Canvas Panel */}
        <div className="canvas-panel">
          {/* Top Tool Bar Component */}
          {!previewOpen && (
            <ToolBar
              toolbarVisible={showToolbar}
              showUploadToolbar={showUploadToolbar}
              elementStrokColor={elementStrokColor}
              Canvaseditor={canvasObj}
              setdisabledObj={setdisabledObj}
              disabledObj={disabledObj}
              showTextToolbar={showTextToolbar}
              setLockObj={setLockObj}
              LockObj={LockObj}
              canvases={canvases}
              canvasObjects={canvasObjects}
            />
          )}

          {/* Main Canvas Editor of the Page */}
          {/* {!previewOpen && */}
          <div className="main-area">
            {loader && <div id="cover-spin"></div>}

            <CanvasArea
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCanvasObjects={setCanvasObjects}
              canvasObjects={canvasObjects}
              setcanvases={setcanvases}
              setcanvasesOriganl={setcanvasesOriganl}
              canvasesOriganl={canvasesOriganl}
              setcanvasObj={setcanvasObj}
              setLoader={setLoader}
              closeTab={closeTab}
              setShowToolbar={setShowToolbar}
              setTextToolbar={setTextToolbar}
              setelementStrokColor={setelementStrokColor}
              setshowUploadToolbar={setshowUploadToolbar}
              templateID={templateID}
              updateID={updateID}
              createID={createID}
              currentPageObject={canvasObj}
              setSelectedIndex={setSelectedIndex}
              setLable={setLable}
              settemplateID={settemplateID}
              onPageCanvasReady={(pageIndex, canvas) => captureInitialStateRef.current?.(canvas, pageIndex)}
            />

            <div className="bottom-section">
              {/* <div className="zomm-canvas">
                <ZoomCanvas Canvaseditor={canvasObj} />
              </div> */}
              <div className="pagination">
                {/* API:- Pagination would be present After it */}
                <Pagination
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  canvasObjects={canvasObjects}
                  setSelectedIndex={setSelectedIndex}
                  selectedIndex={selectedIndex}
                />
              </div>
            </div>
          </div>
          {/* } */}
          {/* {previewOpen &&
            <>
              {loader && <div id="cover-spin"></div>}
              <PreviewScreen
                canvases={canvases}
                templateID={templateID}
                previewOpen={previewOpen}
                images={images}
                setImages={setImages}
                TemplateData={TemplateData}
                setTemplateData={setTemplateData}
                canvasesOriganl={canvasesOriganl}
              />
            </>
          } */}
        </div>
      </div>
    </div >
  );
}
